import { H3, Breadcrumbs } from '../../../../AbstractElements';
import { InvoiceDetails } from '../../../../Constant';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import React, { Fragment, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { getClientUrlDataToken, postDataWithToken } from '../../../../Utils/restUtils';
import { getCart, getProductInvoice, guestPaymentConfirm, guestPaymentRequest } from '../../../../CommonUrl';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import ProductReward from './ProductReward';
import AmountDeliver from './AmountDeliver';

const ProductInvoice = () => {
    const location = useLocation();
    const authState = useSelector((state) => state.auth);
    const queryParams = new URLSearchParams(location.search);
    const order_id = queryParams.get('id');
    const [apiResponse, setapiResponse] = useState(null);

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        const response = await getClientUrlDataToken(getProductInvoice + `?order_id=${order_id}`);
        setapiResponse(response?.data);
    }

    return (
        <Fragment>
            <Breadcrumbs parent="Ecommerce" title="Checkout" mainTitle="Checkout" />
            <Container fluid={true}>
                <Row style={{ marginTop: '80px' }}>
                    <Col>
                        <Card className="checkout">
                            <CardHeader className="pb-0">
                                <H3>{InvoiceDetails}</H3>
                            </CardHeader>
                            <CardBody>
                                <Row style={{ padding: '30px' }}>
                                    <ProductReward />
                                    <AmountDeliver/>
                                </Row >
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};
export default ProductInvoice;